<template>
   <div>
    <b-form @submit="onSubmit" @reset="onReset" v-if="true">
      <b-form-group
        id="input-group-1"
        label="Username:"
        label-for="input-1"
      >
        <b-form-input
          id="input-1"
          v-model="username"
          required
          placeholder="Enter username"
        ></b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2" label="Password:" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="password"
          type="password"
          required
          placeholder="Enter password"
        ></b-form-input>
      </b-form-group>

      <b-button type="submit" variant="primary">Submit</b-button>
      <!-- <b-button type="reset" variant="danger">Reset</b-button> -->
    </b-form>
    <b-card class="mt-3" header="Form Data Result">
      <pre class="m-0">{{ username }} {{ error }}</pre>
    </b-card>
  </div>
</template>

<script>
import auth from '../lib/auth'
import * as types from '../store/mutation-types'

export default {
  data () {
    return {
      username: null,
      password: null,
      error: false,
      validate: false
    }
  },
  methods: {
    onReset (event) {
      event.preventDefault()
      this.form.email = null
    },
    onSubmit (event) {
      event.preventDefault()
      // console.log('SUBMIT')
      auth.login(this.username, this.password, (result) => {
        if (!result || !result.authenticated) {
          this.error = true
        } else {
          console.log('LOGIN RESULT', result)
          console.log('USER PROFILE', result.auth)
          this.$store.commit(types.USER_PROFILE_LOGIN, result.auth)
          Promise.all([
            this.$store.dispatch('fetchProjects')
          ])
          .then(() => {
            console.log('post-login fetch completed')
          })
          .catch(error => {
            console.error('Error: post-login fetch failed with error', error)
          })
          // Promise.all([
          //   this.$store.dispatch('getUser'),
          //   this.$store.dispatch('getConfig')
          // ])
          // .then(() => {
          //   console.log('LOGIN REDIRECTING TO', this.$route.query.redirect)
          //   this.$router.replace(this.$route.query.redirect || '/')
          // })
          // .catch(error => {
          //   console.log('LOGIN getUser/getConfig dispatch error', error)
          //   this.$router.replace('/')
          // })
        }
      })
    }
  }
}
</script>